import { PayloadAction } from '@reduxjs/toolkit'
import { StockAlert, StockAlertState } from 'src/core/models'
import { initialState } from './state'

export const reducers = {
  /* Stock Alert List Reducers */
  setStockAlertLoading: (state: StockAlertState, action: PayloadAction<boolean>) => {
    state.list.loading = action.payload
  },
  setStockAlertList: (state: StockAlertState, action: PayloadAction<StockAlert[]>) => {
    state.list.data = action.payload
  },
  resetStockAlertList: (state: StockAlertState) => {
    state.list = initialState.list
  },
  /* Stock Alert Delete Reducers */
  setStockAlertDeleteLoading: (state: StockAlertState, action: PayloadAction<boolean>) => {
    state.delete.loading = action.payload
  },
  setStockAlertDeleteSuccess: (state: StockAlertState, action: PayloadAction<boolean>) => {
    state.delete.success = action.payload
  },
  resetStockAlertDelete: (state: StockAlertState) => {
    state.delete = initialState.delete
  },
  // Create Stock Alert Reducers
  setStockAlertCreateLoading: (state: StockAlertState, action: PayloadAction<boolean>) => {
    state.create.loading = action.payload
  },
  setStockAlertCreateSuccess: (state: StockAlertState, action: PayloadAction<boolean>) => {
    state.create.success = action.payload
  },
  resetStockAlertCreate: (state: StockAlertState) => {
    state.create = initialState.create
  }
}
